import { applyMiddleware, createStore, combineReducers } from 'redux';
import { createWrapper, HYDRATE, MakeStore } from 'next-redux-wrapper';
import { composeWithDevTools } from 'redux-devtools-extension';

import promise from 'redux-promise-middleware';
import thunk, { ThunkMiddleware } from 'redux-thunk';

import reducers from 'state/reducers';

import { Action, Dispatch, GlobalState } from 'types';

const middleware = [thunk as ThunkMiddleware<GlobalState, Action>, promise];

const allReducers = combineReducers(reducers);

const rootReducer = (state: GlobalState | undefined, action: Action) => {
  if (action.type === HYDRATE) {
    if (!state) return;

    return {
      ...state,
      ...action.payload,
    };
  }

  return allReducers(state, action);
};

const makeStore: MakeStore<GlobalState> = () => {
  const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware<Dispatch, GlobalState>(...middleware))
  );

  return store;
};

export const reduxWrapper = createWrapper<GlobalState>(makeStore, {
  debug: process.env.NODE_ENV !== 'production',
});
